import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
import { ParamsEficienciaEAD, ParamsReportePartidasAclaracion } from "app/models/requireme";

const controller = rpcController("ReportePartidasAclaracion");

/**Resource del reporte de estadísticas de clientes*/
export const RepPartidasAclaracion = cacheResource({
Generar: async (
parametros: ParamsReportePartidasAclaracion): Promise<string> =>
await controller("GenerarReportePartidasAclaracion", {}, parametros)
}, {
}, {
})


// WEBPACK FOOTER //
// ./app/resources/items/reportepartidasaclaracion.tsx